listenerCount